/*{
  "id": 1,
  "meta_execucao_fisico_id": 1,
  "tipo": "Investimento",
  "especificacao": "Construção de infraestrutura",
  "valor_orgao_entidade": 50000,
  "valor_organizacao_sociedade_civil": 30000,
  "created_at": "2025-01-28T15:00:00Z",
  "updated_at": "2025-01-28T15:30:00Z"
}*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postMetasAplicacao = async (
  token: string,
  meta_execucao_fisico_id: number,
  tipo: string,
  especificacao: string,
  valor_orgao_entidade: number,
  valor_organizacao_sociedade_civil: number
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/metas-aplicacao`,
    {
      meta_execucao_fisico_id,
      tipo,
      especificacao,
      valor_orgao_entidade,
      valor_organizacao_sociedade_civil,
    },
    config
  );
  return response.data;
};
export default postMetasAplicacao;
